import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import Login from '../studio/login.vue'
import Map from '../studio/oneMap/oneMap.vue'
import loginGo from '../studio/loginGo.vue'//免密登录

import Home from '../studio/Home.vue'
import Dashborad from '../../src/studio/Dashboard.vue'

/*规范化管理*/
import managementCenter from '../studio/canonical/managementCenter/main'

// 用户管理-认证审核
import listOfLibrary from '../studio/subject/listOfLibrary/main'
import libraryListReviewed from '../studio/subject/libraryListReviewed/main'
import abnormal from '../studio/subject/abnormal/main' //异常管理
import cancellation from '../studio/subject/cancellation/main' //注销管理
// 政策资讯
import policyNews from "../studio/policyNews/policyNews/main.vue"
// ----系统配置-----
// 平台名称配置
import nameConfiguration from "../studio/systemConfig/nameConfiguration/main.vue"

/** */
import demonstration from '../studio/demonstration/Administration/main'
/**首页 */
import homepage from '../studio/homepage/home/index'

import policy from "../studio/policy/main.vue";
import articleDetail from "../studio/policy/components/article.vue";

import publish from '../studio/publish/main.vue'
import manage from '../studio/manage/main.vue'
import projectStatistics from '../studio/projectStatistics/main.vue'

import contractDetails from '../studio/contract/contractDetails/main'

Vue.use(Router);
let router = new Router({
  routes: [
    {
      path: '/homepage',
      name: '首页',
      component: Dashborad,
      children: [
        { path: '/homepage/home', component: homepage },
      ]
    },
    //跳转至登陆页
    { path: '/login', name: '登录', component: Login },
    {
      path: '/policy',
      name: 'policy',
      component: Dashborad,
      children: [
        { path: '/policy/policyList', component: policy },
        {
          path: '/policy/article',
          component: articleDetail,
        },
      ]
    },
    // {
    //   path: '/policy/article',
    //   name: '政策详情',
    //   component: articleDetail,
    // },
    // { path: '/bigScreen', name: '大屏', component: bigScreen },
    // { path: '*', name: '404', component: Home, redirect: '/dashboard', },
    //跳转至首页（App.vue）
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Dashborad,
    //   // redirect: '/dashboard',
    //   children: [
    //     // { name: '首页', path: '/dashboard', component: Dashboard },
    //     // { name: '首页2', path: '/map', component: Map }
    //   ]
    // },
    {
      path: '/oneMap',
      name: 'oneMap',
      component: Map,
    },
    {
      path: '/subject',
      name: '主体名录管理',
      component: Home,
      children: [
        { path: '/subject/listOfLibrary', component: listOfLibrary },
        { path: '/subject/libraryListReviewed', component: libraryListReviewed },
        { path: '/canonical/abnormal', component: abnormal }, /*异常管理*/
        { path: '/canonical/cancellation', component: cancellation }, /*注销管理*/
      ]
    },
    {
      path: '/canonical',
      name: '规范化管理',
      component: Home,
      children: [
        { path: '/canonical/managementCenter', component: managementCenter }, /*规范化管理*/
      ]
    },

    {
      path: '/demonstration',
      name: '示范社管理',
      component: Home,
      children: [
        { path: '/demonstration/Administration', component: demonstration }, /*规范化管理*/
      ]
    },
    {
      path: '/systemConfig',
      name: '平台名称配置',
      component: Home,
      children: [
        { path: '/systemConfig/nameConfiguration', component: nameConfiguration }, /*平台名称配置*/
      ]
    },
    {
      path: '/loginGo',
      component: loginGo,//自动登录
      name: '自动登录',
      menuShow: true,
    },
    {
      path: "/policyNews",
      name: "政策资讯",
      component: Home,
      children: [
        {
          path: "/policyNews/policyNews",
          component: policyNews
        },
      ]
    },
    {
      path: '/contract',
      name: '合同管理',
      component: Home,
      children: [
        { path: '/contract/Details', component: contractDetails },
      ]
    },
    {
      path: '/project',
      name: '项目库管理',
      component: Home,
      children: [
        { path: '/project/publish', component: publish },
        { path: '/project/manage', component: manage },
        { path: '/prject/statistics', component: projectStatistics }
      ]
    },

  ]
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/login')) {
    Cookies.remove('token');
    Cookies.remove('mainPath');
    next()
  } else {
    let user = Cookies.get('token');
    let mainPath = Cookies.get('mainPath');
    if (!user) {
      if (to.path.startsWith('/loginGo')) {//跳转登录判断
        next()
      } else {
        next({ path: '/login' })
      }
    } else if (to.path == '/') {
      next({ path: mainPath })
    } else {
      // if(from.path!=='/projectManagement/taskMap'
      //   && (to.path === '/projectManagement/taskMonitor'
      //     || to.path === '/projectManagement/subsidiesAudit')){
      //     from.meta.keepAlive = false;
      //     next({path: to})
      // }else{
      // }
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js